/*
  G36 · PRECARGA DE FICHAS (se carga en todas las páginas desde layout/theme.liquid)
  Para que al tocar una prenda la ficha abra al instante.

  1. Chrome/Edge/Android (Speculation Rules): cualquier enlace a /products/ se precarga al
     pasar el mouse o al empezar a tocar (prefetch "moderate") y se deja pintada del todo al
     presionar (prerender "conservative"). Las miniaturas de color no se pre-pintan: su
     primer toque solo cambia la foto (assets/g36-ui.js, 5).
  2. Fichas dentro de [data-g36-prefetch] ("También te podría gustar"): se precargan al
     entrar en pantalla (máx. 8 por página).
     En Safari/Firefox no sirve precargar el HTML: Shopify lo manda con
     "private, max-age=0, must-revalidate" y sin 304, así que el navegador lo vuelve a bajar
     al abrir. Ahí solo se pide una vez en baja prioridad para despertar la caché de Shopify
     (≈130 ms → ≈20 ms en el servidor). Por eso no se precarga al tocar: sería doble descarga.
  3. Fuera de la ficha, en reposo, se bajan los CSS/JS que solo usa la ficha
     (data-g36-warm en la etiqueta <script>). Esos sí quedan en caché (1 año) en todos los
     navegadores y la primera ficha que se abre ya no los espera.
  Nada con "Ahorro de datos" o 2G, ni en el editor. Nunca carrito, checkout ni cuenta.
*/
(function () {
  if (window.G36Prefetch) return;
  window.G36Prefetch = true;
  if (window.Shopify && window.Shopify.designMode) return;

  var conn = navigator.connection;
  if (conn && (conn.saveData || /2g$/.test(conn.effectiveType || ''))) return;

  var script = document.currentScript;
  var PRERENDER = false; // false = solo prefetch (si algún píxel cuenta visitas pre-pintadas)
  var MAX_VIEWPORT = 8;
  var PRODUCT_PATH = /\/products\/[^/]+\/?$/;
  var BLOCKED = /\/(cart|checkouts?|account|orders)(\/|$)|\.(js|json|xml|oembed)$/;

  var specRules = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var probe = document.createElement('link');
  var linkPrefetch = !!(probe.relList && probe.relList.supports && probe.relList.supports('prefetch'));

  var done = {};
  var donePath = {};
  var viewportCount = 0;

  /* ---------------------------------------------------------------
     1. SPECULATION RULES (Chromium)
  --------------------------------------------------------------- */

  function addRules(rules) {
    var tag = document.createElement('script');
    tag.type = 'speculationrules';
    tag.textContent = JSON.stringify(rules);
    document.head.appendChild(tag);
  }

  if (specRules) {
    var products = { or: [{ href_matches: '/products/*' }, { href_matches: '/*/products/*' }] };
    var skip = '[target="_blank"], [download], [data-no-prefetch]';
    var rules = {
      prefetch: [
        {
          source: 'document',
          where: { and: [products, { not: { selector_matches: skip } }] },
          eagerness: 'moderate'
        }
      ]
    };
    if (PRERENDER) {
      rules.prerender = [
        {
          source: 'document',
          where: { and: [products, { not: { selector_matches: skip + ', [data-g36-cc-item]' } }] },
          eagerness: 'conservative'
        }
      ];
    }
    addRules(rules);
  }

  /* ---------------------------------------------------------------
     2. RECOMENDADOS AL ENTRAR EN PANTALLA
  --------------------------------------------------------------- */

  // URL de ficha del mismo sitio, sin #; null si no sirve
  function productUrl(link) {
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return null;
    var url;
    try {
      url = new URL(link.href, location.href);
    } catch (e) {
      return null;
    }
    if (url.origin !== location.origin) return null;
    if (!PRODUCT_PATH.test(url.pathname) || BLOCKED.test(url.pathname)) return null;
    url.hash = '';
    if (url.pathname === location.pathname) return null; // la misma ficha
    return url;
  }

  function prefetch(url) {
    var href = url.href;
    // Una vez por ficha: /products/x y /products/x?variant=… cuentan como la misma
    if (done[href] || donePath[url.pathname]) return;
    done[href] = donePath[url.pathname] = true;

    if (specRules) {
      addRules({ prefetch: [{ source: 'list', urls: [href] }] });
    } else if (linkPrefetch) {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    } else if (window.fetch) {
      fetch(href, { credentials: 'same-origin', priority: 'low' }).catch(function () {});
    }
  }

  function watchViewport() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          if (viewportCount >= MAX_VIEWPORT) return;
          var url = productUrl(entry.target);
          if (!url || donePath[url.pathname]) return;
          viewportCount++;
          prefetch(url);
        });
      },
      { rootMargin: '0px 0px 200px 0px' }
    );
    document.querySelectorAll('[data-g36-prefetch] a[href*="/products/"]:not([data-g36-cc-item])').forEach(function (a) {
      io.observe(a);
    });
  }

  /* ---------------------------------------------------------------
     3. CSS/JS DE LA FICHA EN REPOSO
  --------------------------------------------------------------- */

  function warmAssets() {
    var list = ((script && script.getAttribute('data-g36-warm')) || '').split(/\s+/).filter(Boolean);
    list.forEach(function (src) {
      if (linkPrefetch) {
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = src;
        document.head.appendChild(link);
      } else if (window.fetch) {
        fetch(src, { credentials: 'same-origin', priority: 'low' }).catch(function () {});
      }
    });
  }

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };

  var start = function () {
    watchViewport();
    idle(warmAssets, { timeout: 4000 });
  };

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
